import { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { useToast } from '@chakra-ui/react'

import { updateDsr, resetUpdateDsrOutcome } from '../actions/dsr-actions'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { redirectToNewPage, triggerLaunchdeckToast } from '../../global/helpers/global-helpers'
import { removeEmptySubWidgets, removeEmptyWidgets } from '../helpers/dsr-draft-helpers'


function SaveCloseLiveEditButton( {
  dsrId, 
  dsrPages, 
  saveButtonUsed,
  setSaveButtonUsed,
  // Redux
  updateDsrOutcome, 
  isMobileView,
  // Action
  updateDsr,
  resetUpdateDsrOutcome
}) {
  const toast = useToast();

  useEffect(() => {
    if (updateDsrOutcome) {
      const {updateDsrStatus, updatedDsrId, sourceEvent} = updateDsrOutcome || {};
      if ( sourceEvent==="save-draft-dsr" && saveButtonUsed) {
        if (updateDsrStatus && updatedDsrId === dsrId && dsrId !== undefined) {

          dsrId && redirectToNewPage(`/dsr/${dsrId}`)

        } else if (!updateDsrStatus) {
          toast(
            triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: "Unfortunately something went wrong. Please try again later.", 
            isMobileView
            })
          )
        }
  
          resetUpdateDsrOutcome()
          setSaveButtonUsed(false)
      }
    }
  }, [updateDsrOutcome, toast, dsrId, resetUpdateDsrOutcome]);

  function handleClick() {
    setSaveButtonUsed(true)

    const clearedWidgets = removeEmptySubWidgets(dsrPages);
    const filteredDsrPagesLocalState = removeEmptyWidgets(clearedWidgets);

    updateDsr({
      dsrId,
      // Note: Future scope - save only the parts that have changed, and not all the pages. Less risk of wiping out error data.
      dsrPages: filteredDsrPagesLocalState,
      sourceEvent: 'save-draft-dsr'
    })

  }

  return (
    <LaunchdeckButton 
    bg='brandGreen.500' 
    color='white' 
    fontSize='0.8em' 
    loadingLogic={saveButtonUsed}
    onClick={() => handleClick()} label='Update & close' />
  );
}

function mapStateToProps(state) {
  return {
    updateDsrOutcome: state.updateDsrOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView
  };
}


const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
      updateDsr,
      resetUpdateDsrOutcome
		},
		dispatch,
	)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SaveCloseLiveEditButton));
